module.exports = __webpack_public_path__ + "nc_static/media/dd_peripheral_devices.f73ff200.svg";